<template>

<draggable 
v-model="listdata"
class="list-group" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
  <DraggableContentTableLine :dataitem="element" :columns="columns" :name_parameter="name_parameter" :routename="routename" :route_param="route_param" :deleteobjectname="deleteobjectname" :show_index="show_index"></DraggableContentTableLine>
  
</template>




</draggable>



</template>

<script>
import DraggableContentTableLine from "./DraggableContentTableLine"
export default {
  props:["data","columns","routename","deleteobjectname","name_parameter","route_param","show_index"],
  components:{DraggableContentTableLine},
  name: 'DraggableContentTable',

  data () {
    return {
      listdata:[],
      drag:false,
      remove_from_id:null,
      removing_item_id:null,
      add_to_id:null,
      adding_item_id:null,
    }
  },
  methods:{
    onColReorder()
    {
      console.log(data)
    },
    toggle(event,id) {
      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
    end(event)
    {   
      //console.log(event)
      //console.log(this.data)
      this.$emit("listupdated",this.data)
      

      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    relocateItems()
    {
      let formdata = new FormData()       
      formdata.append("add_to_id",this.add_to_id)
      formdata.append("adding_item_id",this.adding_item_id)
      //this.generalSubmission(formdata,"questionlists/"+this.type+"/relocate",this.afterChange)
    },
    reorderItems()
    {
      let formdata = new FormData()       
      formdata.append("add_to_id",this.add_to_id)
      formdata.append("adding_item_id",this.adding_item_id)
      this.generalSubmission(formdata,"questionlists/"+this.type+"/relocate",this.afterChange)
    },
    async change(event)
    {
      await this.relocateItems() 
      
    },
    afterChange(response)
    {
      console.log("response");
      console.log(response.data);
      this.add_to_id = null
      this.adding_item_id = null
    },
  },
  computed:{
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
    realdata()
    {
      return this.data
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
    identifier()
    {
      if(this.identifier_row)
      {
        return this.identifier_row
      }
      else
      {
        return "id"
      }
    },
    identifiername()
    {
      if(this.identifier_row_name)
      {
        return this.identifier_row_name
      }
      else
      {
        return "id"
      }
    },
    is_sortable()
    {
      if(this.sortable)
      {
        return true
      }
      else
      {
        return false
      }
    }
  },
  mounted()
  {
    console.log("newVal")
    console.log(this.data)
    this.listdata = this.data
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.$emit("dataDeleted")
      }
    },

    name_parameter(newval)
    {
      console.log("newVal")
      console.log(newVal)
      this.listdata = newVal
    },
  }
};
</script>

<style lang="css" scoped>
</style>